import React, { Dispatch, SetStateAction } from 'react';
import styled from '../../../components/styled';

import { DateTimeField } from '../../../components';
import { DateTime } from '../../../services/dataModels';

interface CompleteActionFieldProps {
  startTime: DateTime;
  onStartTimeChange: Dispatch<SetStateAction<string>>;
  endTime: DateTime;
  onEndTimeChange: Dispatch<SetStateAction<string>>;
}

const CompleteActionField = ({
  startTime,
  endTime,
  onStartTimeChange,
  onEndTimeChange,
}: CompleteActionFieldProps) => {
  return (
    <>
      <Description>Start Time:</Description>
      <View>
        <DateTimeField
          value={startTime && new Date(`${startTime}`)}
          onValueChange={onStartTimeChange}
        />
      </View>
      <Description>End Time:</Description>
      <View>
        <DateTimeField value={endTime && new Date(endTime + '')} onValueChange={onEndTimeChange} />
      </View>
    </>
  );
};

export default CompleteActionField;

const Description = styled.Text`
  margin-top: 10px;
  font-weight: 500;
  margin-bottom: 7px;
`;

const View = styled.View`
  flex-direction: row;
  align-items: center;
`;
